import {Command} from "../decorators/command.decorator";
import {Employee} from "../domain/entities/employee.entity";
import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

/**
 * Command to delete an employee entity.
 * Accepts the full entity; the transformer extracts the UID for the backend payload.
 */
@Command({type: 'delete', prototype: Employee})
export class DeleteEmployeeCommand extends AbstractCommand<Employee> {

    public name: CommandName = CommandName.DELETE_EMPLOYEE;

    public tags = ['entity', 'delete', 'employee'];

    constructor(payload: Employee) {
        super('employee', payload.uid, payload);
    }

}
